import { ApolloClient, createHttpLink, InMemoryCache } from '@apollo/client';

export const IS_LOCAL_ENVIRONMENT =
  typeof window !== 'undefined' && window.location.host.includes('localhost');

export const IS_TESTING_ENVIRONMENT =
  typeof window !== 'undefined' &&
  // if explicitly set to production, always return false
  new URLSearchParams(window.location.search).get('environment') !== 'production' &&
  // running the code locally
  (process.env.NODE_ENV === 'development' ||
    window.location.host.includes('localhost') ||
    // test pages
    window.location.hostname?.startsWith?.('oneaudi-feature-app') ||
    // query parameter
    new URLSearchParams(window.location.search).get('environment') === 'development' ||
    // checking new QA pages
    window.location.hostname.startsWith('pre-') ||
    window.location.hostname.startsWith('qa'));

export const HOST_NAME = typeof window !== 'undefined' ? window.location.origin : '';

export const OMNIGRAPH_GATEWAY_URL = IS_TESTING_ENVIRONMENT
  ? 'https://qa-omnigraph.audi.com/graphql'
  : 'https://omnigraph.audi.com/graphql';

const omniGraphLink = createHttpLink({
  uri: OMNIGRAPH_GATEWAY_URL,
});

export const apolloClient = new ApolloClient({
  link: omniGraphLink,
  cache: new InMemoryCache(),
  clientAwareness: {
    name: __FEATURE_APP_NAME__,
    version: __FEATURE_APP_VERSION__,
  },
});
